import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "ab-occurrences",
  templateUrl: "./occurrences.component.html",
})
export class OccurrencesComponent implements OnInit {
  @Input() public group: any;

  public total: number;
  public deployAt: string;
  public sinceDeploy: string;

  public ngOnInit() {
    this.total = this.group.noticeCount;
    this.deployAt = this.group.lastDeployAt;

    if (this.group.lastDeployNoticeTotalCount === this.group.noticeCount) {
      this.sinceDeploy = "all";
    } else if (this.group.lastDeployNoticeTotalCount === 0) {
      this.sinceDeploy = "none";
    } else {
      this.sinceDeploy = this.group.lastDeployNoticeTotalCount;
    }
  }
}
